// styles
import { chartDashboardBoxStyle, chartDashboardType04Style } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledRiskAssessmentWorkRisk = styled.div`
  ${chartDashboardBoxStyle}
  ${chartDashboardType04Style}
`;
